module.exports = __webpack_public_path__ + "img/nav-1-active.a512293.png";